import { ContextWrapper } from "@common/contexts";
import { HospitalAppStore } from "@hospital/stores/rootStores";

export const HospitalAppStoreContextWrapper = new ContextWrapper<HospitalAppStore>();
